const lan = {
  REDIRECT: "Meneruskan...",
  RULE: {
    SERVICE_TYPE: "Silakan pilih Jenis layanan",
    COUNTRY: "Silakan pilih negara atau wilayah Anda",
    USERNAME: "Nama (wajib)",
    EMAIL: "E-mail (wajib)",
    EMAIL2: "Silakan masukkan format email yang benar.",
    PRODUCT: "Pilih Product Anda",
    PRODUCTSN: "Silakan masukkan nomor Serial Produk Anda",
    PRODUCTSN_LEN: "Silahkan masukkan 12 sampai 15 hurup atau angka",
    BIRTHDAY: "Tanggal lahir (wajib)",
    REQUIRED: "Wajib",
  },
  SYS: {
    HEAD: "Sistem",
    NOSERVICE:
      "Maaf, ASUS Chat untuk negara atau wilayah yang Anda pilih tidak tersedia.",
    CHECK_FILESIZE: "Silakan periksa ukuran gambar dan file. Batas ukuran:",
    RECONNECTED: "Status koneksi telah kembali normal",
    UNABLE_SEND: "Tidak dapat mengirim lampiran",
    NO_NETWORK: "Tidak ada sambungan Internet",
    NO_NETWORK_INFO:
      "Tidak ada koneksi internet. Sambungkan ke internet dan coba lagi",
  },
  IDLE: {
    HEAD: "Anda Belum merespon. Apakah anda ingin melanjutkan?",
    BUTTON: "Lanjutkan",
  },
  DISCONNECT: {
    HEAD: "Chat telah berakhir",
    BUTTON: "Akhiri",
  },
  LAYOUT: {
    STEP_1: "Pilih Produk",
    STEP_2: "Ketentuan dan Syarat Layanan",
    STEP_3: "Masuk",
    STEP_4: "Informasi",
    SELECT_SKILL: "Pilih Produk",
    PREV_STEP: "Sebelumnya",
    NEXT_STEP: "Selanjutnya",
    NOTSET: "Pengaturan",
    AGREEN: "Setuju",
    NOTAGREEN: "Tidak Setuju",
    LEAVE: "Meninggalkan",
    TYPE_HERE: "Ketik disini",
    CHAT_DOWNLOAD:
      "Silakan klik di sini untuk menyimpan salinan Obrolan Anda dengan ASUS Online Customer Service.",
  },
  COUNTRY: { SELECT_COUNTRY: "Silakan pilih negara atau wilayah Anda" },
  POLICY: {
    PRIVACY: "Kebijakan atas Perlindungan Privasi",
    SAT_SURVEY: "Perjanjian Layanan",
    CONFIRM_COUNTRY: {
      H1: "Pelanggan yang terhormat",
      P1:
        "Anda saat ini mengunjungi “ASUS Online Customer Service” di situs Indonesia yang berbeda dari wilayah Anda saat ini. Berdasarkan Kebijakan atas Garansi ASUS, tidak semua produk ASUS berlaku untuk layanan Garansi dan Dukungan Internasional ASUS. Jika situs wilayah di atas yang Anda kunjungi bukan wilayah tempat Anda membeli produk ASUS, atau berbeda dari wilayah Anda saat ini, hal itu dapat memengaruhi hak Anda. Anda dapat terus menggunakan “ASUS Online Customer Service” di situs Indonesia, atau pilih “ASUS Online Customer Service” untuk wilayah Anda.",
      P2: "",
      P3: "",
      B1: "Pindah ke ASUS",
      B2: "Situs Web",
      B3: "Tetap melanjutkan",
    },
    BULLETIN: {
      HEAD: "Pesan Penting",
      CONFIRM: "Terkonfirmasi",
    },
  },
  SURVEY: {
    SURVEY_ENTER: "Silahkan mengisi informasi kontak",
    SURVEY_TYPE: "Silakan pilih Jenis layanan",
    PROBLEM_BRIEF: "Bagaimana deskripsi masalah Anda?",
    TYPE1: "Pertanyaan Umum",
    TYPE2: "Mengenai Perbaikan",
    TYPE3: "Dukungan Tehnik",
    TYPE4: "Mengenai Garansi",
    TYPE5: "Pendapat dan Saran",
    EC_TYPE1: "Informasi Product dan Penjualan",
    EC_TYPE2: "Acara Pemasaran",
    EC_TYPE3: "Pengiriman dan satus pemesanan",
    EC_TYPE4: "Layanan Pengembalian",
    SIGNUPDATA: "Informasi Pendaftaran Anda",
    NAME: "Nama",
    TEL: "Telepon",
    ORDER_NO: "No Order.",
    BIRTHDAY: "Hari lahir",
    LABEL_EMAIL: "E-mail",
    EMAIL: "E-mail",
    DEVICEINFO: "Informasi Produk",
    DEVICENAME: "Nama Produk",
    MY_DEVICE: "Produk Anda",
    MY_DEVICE_SELECT: "Pilih Produk Anda",
    MY_DEVICE_EMPTY: "Anda belum memiliki Produk.",
    LABEL_DEVICESN: "Nomor Seri",
    DEVICESN: "Nomor Seri Produk",
    DEVICESN_ERROR: "Nomor Seri unit salah.",
    PREPARE: "Membuat ruang chat dan siap melakukan chat",
    START: "Memulai Chat",
    AGE_LIMIT: "Batas umur",
    AGE_LIMIT_DESC:
      "Kamu tidak memenuhi persyaratan untuk menggunakan Layanan Chat ASUS",
    REPEAT_ENTRY: {
      H1: "Ruang percakapan masih terisi",
      P1:
        "Apakah Anda yakin ingin memulai percakapan baru? Saat percakapan baru dibuka, percakapan lama akan berakhir.",
      B0: "Konfirmasi",
      B1: "Batal",
    },
  },
  CONNECTTING: {
    P1: "Silakan Tunggu sebentar dan tetap di layanan Chat",
    P2: "Tersambung ke agent",
    NOTE: "Petunjuk",
    BEFORE_LEAVE: "Apakah Anda akan mengkhiri Chat?",
    B0: "Mengakhiri",
    B1: "Tetap dan Menunggu",
  },
  OFFLIEN: {
    OTHER_CONTACT: "Hubungi ASUS melalui Layanan lain",
    MAIL: "Hubungi Kami- E-mail",
    TEL: "Hubungi Kami- Telepon",
    CLOSE: "Tutup",
  },
  WAITTING: {
    WATTING_NUM: "Nomor antrian",
    PEOPLE: "Pelanggan",
    NOTE: "Petunjuk",
    BEFORE_LEAVEL: "Apakah yakin keluar dari antrian?",
    LEAVE_DESC:
      "Silakan menunggu beberapa saat lagi atau Anda dapat meninggalkan layanan chat",
    LEAVE: "Meninggalkan Antrian",
    STAY: "Tetap dan menunggu",
  },
  CHATROOM: {
    TYPING: "Agen mengetik...",
    HEAD: {
      CLOSE_AMD_SURVEY: "Akhiri Chat",
      TERMINATE: "Mengakhiri chat",
    },
    FOOTER: { CHAT_FINISH: "Percakapan berakhir" },
    FINISH:
      "Percakapan Selesai, Apakah anda membutuhkan dukungan layanan lain?",
    SAT_SURVEY: {
      SAT: "Puas",
      DISSAT: "Tidak Puas",
      SAT_CHOOSE: "Jenis Layanan? (Bisa lebih dari satu)",
      HEAD: "Apakah Anda Puas dengan layanan Chat yang diberikan?",
      DESC:
        "Saran dan Pendapat anda adalah hal yang berharga untuk selalu meningkatkan Layanan Kami Selanjutnya, Silakan berikan Saran atau Pendapat anda untuk layanan ASUS.",
      OTHER_OPTION: "Lain",
      OTHER_REASON: "Alasan lain",
      SEND: "Kirim",
    },
    CLOSE: {
      TITLE: "Anda yakin ingin mengakhiri?",
      P1:
        'Klik “Akhiri" Untuk menutup. Anda dapat memulai kembali layanan chat, dengan melakukan login kembali".',
      B0: "Tutup",
      B1: "Batal",
    },
  },
  ERROR: {
    H1: "Ruang Chat tidak ada atau Chat telah berakhir",
    CLOSE: "Tutup",
  },
  CHAT_END: {
    H1: "Terima Kasih, Chat telah berakhir",
    CLOSE: "Tutup",
  },
  CHAT_CLOSE: {
    H1:
      "Jaringan Anda terputus selama lebih dari 300 detik, sehingga kami telah menghentikan percakapan ini.",
    DESC:
      "Jika Anda menggunakan jaringan nirkabel atau jaringan seluler, cobalah mencari lokasi dengan sinyal yang lebih baik; atau beralih ke koneksi jaringan kabel, maaf atas ketidaknyamanannya',",
    CLOSE: "Tutup",
  },
  SURVEY_DONE: {
    H1: "Terima Kasih. Anda telah menyelesaikan Layanan Survey kepuasan",
    P1:
      'Kami sangat menghargai Saran Anda untuk kemajuan Asus selanjutnya. Terima kasih telah meluangkan waktu untuk mengisi survei kepuasan ini. Jika Anda memiliki pertanyaan lain atau memerlukan dukungan dari agent kami, silakan klik "Hubungi kami - Online chat". atau silakan kilk " Tutup Layanan" untuk mengakhiri',
    AGAIN: "Hubungi kami-Online Chat kembali",
    CLOSE: "Tutup",
    YT_H1: "Temukan kiat dan pengetahuan teknologi dengan dukungan Video ASUS.",
    YT_H2: "Klik untuk menjelajah!",
  },
  AGENT_OFFLINE: {
    H1:
      "Koneksi Internet agen tidak merespons; percakapan Anda saat ini terganggu",
    H2:
      "Tolong jangan tutup jendela percakapan; kami berusaha keras untuk melanjutkan percakapan",
    DESC:
      "Anda juga dapat memilih untuk mengakhiri sesi untuk melakukan survei, atau klik 'Mulai Obrolan baru', dan kami akan segera menetapkan agen baru untuk melanjutkan sesi. Maaf atas ketidaknyamanan yang terjadi',",
    AGAIN: "Mulai percakapan Baru",
  },
  VIDEOCALL: {
    MEDIA_NOTALLOW: "Tidak dapat menggunakan kamera dan mikrofon",
    H1: "Siap bergabung?",
    P1:
      "Agar staf layanan pelanggan ASUS dapat membantu Anda menyelesaikan masalah dengan lebih efisien, Anda harus mengizinkan perangkat mengakses kamera dan mikrofon Anda untuk bergabung ke ruang percakapan video, dan pastikan koneksi jaringan seluler Anda stabil dan berfungsi normal",
    P2:
      "Setelah mengakses, Anda masih dapat dengan bebas mengatur pengalihan kamera anda dan mematikan mikropon.",
    VIDEO_STATE: "Status Video",
    VIDEO_ON: "On",
    VIDEO_OFF: "Off",
    AUDIO_STATE: "Status Audio",
    AUDIO_ON: "On",
    AUDIO_OFF: "Off",
    ENTER: "Gabung",
    HANGUP: {
      H1: "Tutup",
      P1: "Apakah Anda yakin untuk menutup percakapan video?",
      CONFIRM: "Konfirmasi",
      CANCEL: "Batal",
    },
    END: {
      H1: "Panggilan Video telah berakhir",
      P1:
        "Terima kasih, percakapan video ini telah selesai, Anda dapat menutup jendela ini.",
    },
  },
  GPT: {
    LAYOUT: {
      STEP_1: "Pilih Produk",
      STEP_2: "Ketentuan dan Syarat Layanan",
      STEP_3: "Masuk",
      STEP_4: "Informasi",
      SELECT_SKILL: "Pilih Produk",
      WELCOME: "Selamat datang",
      AGREE: "Setuju",
      START: "Mulai",
      CANCEL: "Batal",
      WAIT: "Mohon tunggu",
      INPUT: "Masukkan teks",
      TRANSFER_TOAGENT: "Teruskan ke agent.",
      READMORE:
        "Anda juga dapat merujuk pada FAQ terkait berikut ini, terima kasih.",
      COLLAPSE: "Sembunyikan",
      INPUT_SN: "Silakan masukkan kembali nomor seri",
      YOU_MAY_ALSO: "Anda mungkin juga ingin bertanya:",
      FOR_FURTHER: "Untuk informasi lebih lanjut, silakan lihat:",
      RECORDING: "Silakan mulai berbicara...",
      RECORDING_NOT_SUPPORTED:
        "Browser Anda tidak mendukung pengenalan suara",
      RECORDING_NOT_FOUND:
        "Mikrofon tidak terdeteksi. Silakan periksa mikrofon dan izin akses Anda.",
    },
    IS_COMPONENT_SN:
      "The input is the component serial number, you should enter the correct machine serial number.",
    WARRANTY: {
      SERIES: "Jenis Produk",
      MODEL: "Nama Produk",
      SERIALNO: "Nomor Seri Produk",
      STATUS: "Status Garansi",
      DATE: "Tanggal Berakhir Garansi",
    },
    HEAD: {
      LEAVE: "Meninggalkan",
      CREATE_NEW: "Buat room baru",
    },
    ENTRANCE: {
      POLICY: "Kebijakan pribadi",
      AGREE: "Klik Setuju untuk memulai percakapan",
    },
    MESSAGE: {
      WAIT: "Mohon tunggu, kami sedang mencari solusi untuk Anda.",
    },
    END: "Percakapan Berakhir",
    END_MSG:
      "Kami dengan senang hati melayani Anda. Semoga hari Anda menyenangkan.",
    END_SURVEY: "Survey Kepuasan",
    END_SURVEY_MSG:
      "Kami dengan senang hati melayani Anda. Semoga hari Anda menyenangkan.",
    BACKHOME: "Kembali ke beranda",
    SURVEY: {
      DESC:
        "Berikan penilaian anda atas pengalaman menggunakan ASUS Virtual assistant.",
      SAT: "Puas",
      DISSAT: "Tidak Puas",
      FEEDBACK: "Silahkan berikan tanggapan Anda.",
      SEND: "Kirim",
      BACK: "Batal",
    },
    SURVEY_DISLIKE: {
      H1: "Mengapa Anda tidak puas dengan jawabannya?",
      P: "Masukan Anda membantu kami meningkatkan kualitas layanan kami.",
      BUTTON: "Kirim",
    },
    HISTORY: {
      TITLE: "Riwayat",
      AGO: "{hours} Jam lalu",
      CONTINUE: "Teruskan Percakapan",
      CLOSE: "Percakapan telah berakhir.",
      RESTART: "Mulai ulang dengan Virtual assistant",
      NON_SERVICE: "Bukan Jam layanan",
      VIEW_HISTORY: "Klik untuk melihat riwayat Percakapan terakhir.",
    },
  },
};
export default lan;
